import { UiButton } from 'teacher-ui-client/components/ui-button'
import { RolloverState } from 'teacher-ui-client/school-rollover/manage-rollover-states'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { eq } from 'ember-truth-helpers'
import { on } from '@ember/modifier'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface Args {
  manageRolloverState: RolloverState
  startRollover: () => void
  continueRollover: () => void
  oppositeSubscriptionType: SubscriptionType
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
}

export const RolloverStartButton: TOC<Signature> = <template>
  {{#if @manageRolloverState}}
    <div data-test-rollover-start class="inline-block" ...attributes>
      {{#if (eq @manageRolloverState RolloverState.Open)}}
        <UiButton @appearance={{ButtonAppearance.regular}} {{on "click" @startRollover}}>
          {{t "manage.rollover.wizard.startButton.start"}}
        </UiButton>
      {{else if (eq @manageRolloverState RolloverState.InProgress)}}
        <UiButton @appearance={{ButtonAppearance.regular}} {{on "click" @continueRollover}}>
          {{t "manage.rollover.wizard.startButton.continue"}}
        </UiButton>
      {{else if (eq @manageRolloverState RolloverState.Locked)}}
        <UiButton disabled={{true}} @appearance={{ButtonAppearance.regular}}>
          {{t "manage.rollover.wizard.startButton.start"}}
        </UiButton>
        <Tooltip
          data-test-start-rollover-disabled-tooltip
          @text={{t
            "manage.rollover.wizard.startButton.disabledTooltip"
            oppositeSubscriptionType=(t @oppositeSubscriptionType)
          }}
        />
      {{/if}}
    </div>
  {{/if}}
</template>

export default RolloverStartButton
